export const INIT_REGISTER_USER = 'INIT_REGISTER_USER';
export const REGISTER_USER = 'REGISTER_USER';

const SET_USER_REGISTRATION_INFO = 'SET_USER_REGISTRATION_INFO';

// intial state object
const initialRegisterState = {
  userInfo: null
};

export const registerReducer = (registerState = initialRegisterState, action = null) => {
  switch (action && action.type) {
    // here are actions which *only* want sagas
    case INIT_REGISTER_USER:
    case REGISTER_USER:
    default:
      return registerState;

    case SET_USER_REGISTRATION_INFO:
      return {
        ...registerState,
        userRegistrationInfo: action.payload.userRegistrationInfo
      };
  }
};

//******************************
export const registerActions = {
  initUserRegistration: (userId) => ({ type: INIT_REGISTER_USER, payload: { userId: userId } }),
  setUserRegistrationInfo: (userRegistrationInfo) => ({
    type: SET_USER_REGISTRATION_INFO,
    payload: { userRegistrationInfo: userRegistrationInfo }
  }),
  registerUser: (userId, registrationInfo) => ({
    type: REGISTER_USER,
    payload: { userId: userId, registrationInfo: registrationInfo }
  })
};

//******************************
export const registerSelectors = {
  userRegistrationInfo: (state) => state.register.userRegistrationInfo
};



// WEBPACK FOOTER //
// ./src/modules/register/reducer/register-reducer.js